module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "fade-in-only grey--text",
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "250px",
      "color": "#ccc"
    }
  }, [_vm._v("chat_bubble_outline")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#aaa",
      "padding-left": "18px",
      "margin-top": "-10px"
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13105211"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/NoRecordsPlaceholder.vue
// module id = 2456
// module chunks = 1